import React, { useEffect, useState } from 'react'
import { PermIdentity, Timeline, Person4 } from "@mui/icons-material"
import { NavLink } from 'react-router-dom';
import Toptag from "../toptag/Toptag"
import "./card.css"
import apiFunctions from '../../api/apiFunctions';




export default function Card() {
    // We only need the total_count, not the rows — fetch 1 record, not 1000
    // (1000 was why the count "loaded after a long time"). Guard so a slow/failed
    // call doesn't flash 0.
    const [limit, setLimit] = useState('1');
    const [searchKey, setSearchKey] = useState('');
    const [page, setPage] = useState("1")
    const [usersCount, setUsersCount] = useState({ users: 0})
    const [eventCount, setEventCount] = useState({ events: 0})

    let formatter = Intl.NumberFormat('en', { notation: 'compact' });


    async function fetchUsersCount() {
        try {
            const users = await apiFunctions.getAllUsers(limit, searchKey, page);
            const total = users && users.data && users.data.total_count;
            if (typeof total === 'number') setUsersCount({ users: total });
        } catch (e) { /* keep last good value */ }
    }

    async function fetchEventCount() {
        try {
            const events = await apiFunctions.getAllEvents(limit, searchKey, page);
            const total = events && events.data && events.data.total_count;
            if (typeof total === 'number') setEventCount({ events: total });
        } catch (e) { /* keep last good value */ }
    }

    useEffect(() => {
        // eslint-disable-next-line
       
        //  console.log(data,"useStatae data-----------")
        fetchUsersCount()
        fetchEventCount()
    }, [])


    return (
        <>
        <Toptag />
            <div className="container">
                <div className="cardWrapper">
                    <NavLink to='/home/users' className='link'>
                        <div className="cardContainer">
                            <div className="cardTopLogo ">
                                <Person4 className='cardLogo' />
                            </div>
                            <span className='cardTitle green'>Users</span>
                            <span className='userCount'><Timeline className='trendingLogo' />{formatter.format(usersCount.users)}</span>
                        </div>
                    </NavLink>
                    <NavLink to='/home/events' className='link'>
                        <div className="cardContainer">
                            <div className="cardTopLogo ">
                                <Person4 className='cardLogo' />
                            </div>
                            <span className='cardTitle green'>Events</span>
                            <span className='userCount'><Timeline className='trendingLogo' />{formatter.format(eventCount.events)}</span>
                        </div>
                    </NavLink>
                </div>
            </div>
        </>
    )
}
